import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import React from "react";
import {Tag} from "antd";

const AutoCheckModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    
    columns.push({key:'id', width: 80, filter:true, sorter:true, title:<Trans>ID</Trans>});
    columns.push({key:'supplier.code', dataIndex: ['supplier', 'code'], width: 150, filter:true, sorter:true, title:<Trans>Supplier Code</Trans>});
    columns.push({key:'supplier.name', dataIndex: ['supplier', 'name'], width: 250, filter:true, sorter:true, title:<Trans>Supplier Name</Trans>});
    columns.push({key:'country', width: 150, filter:true, sorter:true, title:<Trans>Country</Trans>});
    columns.push({key:'locationName', dataIndex: ['location', 'name'], width: 250, filter:true, sorter:true, title:<Trans>Location</Trans>});
    columns.push({key:'type', width: 400, filter:true, sorter:true, title:<Trans>Type</Trans>});
    columns.push({
        key: 'result',
        filter:true,
        sorter: true,
        width: 300,
        title: <Trans>Result</Trans>,
        render: text => {
            let color = 'gray';
            let transText = text;
            if (
                text === 'NO' ||
                text === 'LOW_RISK' ||
                text === 'LOW_RISK_CATEGORY' ||
                text === 'FREE'
            ) {
                color = 'green';
                transText = text;
            } else if (
                text === 'YES' ||
                text === 'HIGH_RISK' ||
                text === 'HIGH_RISK_CATEGORY' ||
                text === 'NOT_FREE'
            ) {
                color = 'red';
                transText = text;
            } else if (
                text === 'NEGLIGIBLE_RISK' ||
                text === 'STANDARD_RISK_CATEGORY' ||
                text === 'PARTLY_FREE'
            ) {
                color = 'orange';
                transText = text;
            }
            return (
                <Tag color={color} key={text}>
                    {transText}
                </Tag>
            );
        },
    });

    columns.push({key:'updatedDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 200, filter:true, sorter:true, title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Created Date</Trans>, direction:"desc"});
    columns.push({key:'createdBy', width: 200, filter:true, sorter:true, title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/auto-checks"
    };

}
export default AutoCheckModel();
